// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointmen_header {
  display: flex;
  justify-content: start;
  gap: 57px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentsComponents/AppointmentsHeader/AppointmentsHeader.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAFJ","sourcesContent":["@import \"../../../../styles/colors\";\r\n@import \"../../../../styles/_typography.scss\";\r\n\r\n.appointmen_header {\r\n    display: flex;\r\n    justify-content: start;\r\n    gap: 57px;\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
